import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '@app/store/reducer'

const therapistsStateSelector = (state: AppState) => state.therapists

export const therapistsListSelector = createSelector(therapistsStateSelector, ({ data }) => {
  return data?.providers || []
})
